import loginApi from '@/api/login'
import api from '@/api/api'
import { setUserAccountId, setUserName, setToken, setUserId, setUserRole, removeUserRole, removeUserId, removeToken, removeUserName } from '@/utils/cookie'

const user = {
  state: {
    name: ''
  },

  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    }
  },

  actions: {
    // 用户名登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginApi.login(userInfo).then(resp => {
          console.info(resp)
          setUserName(resp.userName)
          setToken(resp.token)
          /* setUserAccountId(userInfo.loginName) */
          setUserId(resp.loginName)
          setUserRole(resp.role)
          commit('SET_NAME', resp.userName)
          resolve(resp)
        }).catch(error => {
          console.info(error)
          reject(error)
        })
      })
    },
    // 设置密码
    setpwd({ commit }, setPwdInfo) {
      return new Promise((resolve, reject) => {
        loginApi.setpwd(setPwdInfo).then(resp => {
          resolve(resp)
        }).catch(error => {
          console.info(error)
          reject(error)
        })
      })
    },
    // 微信配置列表
    wxserviceList({ commit }) {
      return new Promise((resolve, reject) => {
        api.wxserviceList().then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    },
    wxservicePaymentSettings({ commit }, data) {
      return new Promise((resolve, reject) => {
        api.wxservicePaymentSettings(data).then(resp => {
          resolve(resp)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_NAME', '')
        removeUserRole()
        removeUserId()
        removeToken()
        removeUserName()
        resolve()
      })
    }

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js